import React from 'react';
import { ContentRenderer } from '@jetshop/ui/ContentRenderer';
import { useQuery } from 'react-apollo';
import { contentEditorComponents } from './ContentEditorComponents';
import Spinner from '../ui/Spinner';
import { styled } from 'linaria/react';
import ContentPageContentQuery from '../ContentPage/ContentPageContentQuery.gql';
import DynamicContent from '../DynamicContent';

const SpinnerWrapper = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DynamicPageContentRenderer = ({ pageId, rendererComponents }) => {
  const { data, loading, error } = useQuery(ContentPageContentQuery, {
    variables: {
      id: pageId,
    },
  });

  if (loading) {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
  }
  if (!data || error) {
    return null;
  }
  const components = rendererComponents ?? contentEditorComponents;
  const items = data?.page?.data?.items;

  return (
    <>
      {items ? (
        <ContentRenderer items={items} components={components} />
      ) : (
        <DynamicContent content={data?.page?.content} />
      )}
    </>
  );
};
